import { sendRequest } from '@html/_common/utils';

export default class AOTourPriceGuaranteePopup {
  constructor(eventCategory) {
    this.eventCategory = eventCategory;
    this.TEMPLATES_ENDPOINT = '/api/tours/above-fold-templates';

    this.selectors = {
      wrapper: '.js-ao-tour-price-guarantee-popup__overlay',
      trigger: '.js-ao-tour-above-fold__price-guarantee--learn-more',
      closeBtn: '.js-ao-tour-price-guarantee-popup__close',
    };
    this.templateLoading = false;
    this.templateLoaded = false;
  }

  init() {
    $('body').on('click', this.selectors.closeBtn, () => {
      this.togglePopup(false);
    });

    $('body').on('click', this.selectors.trigger, () => {
      if (this.templateLoading) {
        return;
      }
      if (!this.templateLoaded) {
        this.loadPopup();
        return;
      }
      this.togglePopup(true);
    });
  }

  loadPopup() {
    this.templateLoading = true;
    sendRequest(this.TEMPLATES_ENDPOINT, {
      action: 'price-guarantee/price-guarantee-popup',
    }, (data) => {
      this.templateLoading = false;
      if (data.success === true) {
        this.templateLoaded = true;
        $('body').append(data.component);
        this.togglePopup(true);
      }
    }, {}, () => {
      this.templateLoading = false;
      this.templateLoaded = false;
    });
  }

  togglePopup(toggle) {
    $('body').toggleClass('layer', toggle);
    $('html').toggleClass('layer', toggle);
    $(this.selectors.wrapper).toggleClass('hid', !toggle);

    if (toggle) {
      if (!$.magnificPopup) return;

      $.magnificPopup.close();
    }
  }
}
